// 확장자를 적는 이유: 이 파일은 단위 테스트가 앱 번들 밖(node)에서 그대로 읽는다 — node ESM 은 상대 경로의
// 확장자를 추론하지 않는다. webpack 은 확장자가 있어도 같은 파일을 찾는다.
import { PARTNER_LINK_ACTION } from './partnerLink.js'
import { STORE_FORM_TABS } from './storeDetailForm.js'
import { TV_COUPON_ACTION } from './tvCoupon.js'

/**
 * **매장 정보 관리(`StoreInfoView`)의 탭 — 이 세션에 어느 탭이 있는가, 한 곳.** 의존성 없는 순수 모듈이다(Vue·스토어·`@/` 별칭 금지).
 *
 * 이 화면은 매장 폼의 여섯 탭([STORE_FORM_TABS], `StoreFormTabs` 가 그린다) 뒤에 자기 탭을 붙이고, 그 탭은 **세션 액션이 있을
 * 때만** 생긴다 — 액션 없는 세션에 탭을 그리면 그 탭의 첫 조회가 403 이고, 이 앱의 403 은 로그아웃이다.
 *
 * 「어느 탭을 어느 액션이 여는가」를 여기 둔다: 화면의 탭·요약줄 chip(`v-if`)과 주소가 고르는 처음 탭(`?tab=<pane name>`)이 같은
 * 목록([storeInfoTabs])을 읽는다. 따로 적으면 주소가 이 세션에 없는 탭을 골라 **어느 탭도 펼쳐지지 않는 빈 화면**이 열린다
 * (`storeFormTab` 머리말의 그 증상). 처음 탭의 판정은 `storeFormTab` 그대로다 — 모르는 값·이 세션에 없는 탭은 첫 탭(`info`).
 */

/** 이 화면의 탭 — 매장 폼의 탭 뒤에, 그리는 순서대로. `name` 은 `<el-tab-pane name>`, `action` 은 그 탭을 여는 세션 액션 */
export const STORE_INFO_OWN_TABS = Object.freeze([
  /** 외부 채널 연동(KT 우리동네·네이버 플레이스) — POS2 Lite 「플레이스 연동」 카드가 `?tab=partner` 로 연다 */
  Object.freeze({ name: 'partner', action: PARTNER_LINK_ACTION.VIEW }),
  /** 우리동네TV 쿠폰(R-C) — 서버 SQL 032 에 메뉴 행이 없어 이 탭이 매장 계정의 진입점이다 */
  Object.freeze({ name: 'tvCoupon', action: TV_COUPON_ACTION.LIST }),
])

/**
 * 이 세션의 탭 이름 — 매장 폼의 탭 + 액션이 있는 이 화면의 탭, 그리는 순서대로(새 배열).
 *
 * 세션만 본다. 이 화면의 탭은 상세(`storeCd`)를 읽은 뒤에 그려지지만 처음 탭은 그 전에 정해도 된다 — `el-tabs` 는 펼친 탭을
 * 이름으로 고르므로 그 pane 이 나중에 생겨도 생기는 순간 펼쳐진다.
 *
 * @param {(action: string) => boolean} can 세션 액션 술어 — 화면은 `checkAuthActionAccess` 를 넘긴다
 * @returns {Array<string>}
 */
export function storeInfoTabs(can) {
  return STORE_FORM_TABS.concat(STORE_INFO_OWN_TABS.filter((tab) => can(tab.action)).map((tab) => tab.name))
}
